import Vue from 'vue'

// ✅ 注册页白名单
const standalonePages = [
  'regist_ps2hs',
  'regist_home_older',
  'regist_caohejing',
  'regist_nursing_home',
  'regist_gongdi'
]

// ✅ 当前路径是否是独立注册页
const currentPath = location.hash.replace(/^#\//, '').split('?')[0]
const isStandalonePage = standalonePages.includes(currentPath)

if (isStandalonePage) {
  import('element-ui').then(ElementUI => {
    import('element-ui/lib/theme-chalk/index.css')
    Vue.use(ElementUI.default)

    import('vue-cookie').then(VueCookie => {
      Vue.use(VueCookie.default)

      import('@/utils/httpRequest').then(httpRequest => {
        Vue.prototype.$http = httpRequest.default || httpRequest

        import('vue-router').then(VueRouter => {
          Vue.use(VueRouter.default)

          // ✅ 按路径动态加载组件
          const routePath = '/'+currentPath
          const routeComponent = () => import(`./views/common/${currentPath}.vue`)

          const router = new VueRouter.default({
            mode: 'hash',
            routes: [
              {
                path: routePath,
                component: routeComponent
              }
            ]
          })

          new Vue({
            router,
            render: h => h('router-view')
          }).$mount('#app')
        })
      })
    })
  })
} else {
  // ✅ 正常主应用加载
  import('vue-cookie').then(VueCookie => {
    Vue.use(VueCookie.default)

    import('@/utils/httpRequest').then(httpRequest => {
      Vue.prototype.$http = httpRequest.default || httpRequest

      import('./router').then(router => {
        import('./store').then(store => {
          import('element-ui').then(ElementUI => {
            import('element-ui/lib/theme-chalk/index.css')
            Vue.use(ElementUI.default)

            // 修改主题
            import('../theme/index.css')

            // 内嵌样式、埋点等
            import('@/utils/aegis.js')
            import('@/assets/scss/index.scss')
            import('@/icons')

            // 组件/插件
            import('@/utils/htmlToPdf').then(mod => Vue.use(mod.default || mod))
            import('@/utils/htmlToPdf_horizon').then(mod => Vue.use(mod.default || mod))
            import('vue-signature-pad').then(mod => Vue.use(mod.default || mod))

            // 注册 FontAwesome
            import('@fortawesome/fontawesome-svg-core').then(fontawesome => {
              const { library } = fontawesome

              import('@fortawesome/free-solid-svg-icons').then(solid => {
                const {
                  faHeartPulse, faCircleH, faFileWaveform, faSquareH, faVial, faHardDrive, faDroplet, faStethoscope,
                  faWeightScale, faTemperatureThreeQuarters, faCubes, faFlask, faPersonBreastfeeding, faUserNurse,
                  faUserGroup, faUserDoctor, faHouseMedical, faPeopleRoof, faFileSignature, faBuildingShield,
                  faGears, faBaby, faHeartCirclePlus, faRing
                } = solid

                import('@fortawesome/free-regular-svg-icons').then(regular => {
                  const { faCircle } = regular
                  library.add(
                    faHeartPulse, faCircleH, faFileWaveform, faSquareH, faVial, faCircle, faHardDrive, faDroplet,
                    faStethoscope, faWeightScale, faTemperatureThreeQuarters, faCubes, faFlask, faPersonBreastfeeding,
                    faUserNurse, faUserGroup, faUserDoctor, faHouseMedical, faPeopleRoof, faFileSignature,
                    faBuildingShield, faGears, faBaby, faHeartCirclePlus, faRing
                  )

                  import('@fortawesome/vue-fontawesome').then(iconModule => {
                    const { FontAwesomeIcon } = iconModule
                    Vue.component('font-awesome-icon', FontAwesomeIcon)

                    import('@jiaminghi/data-view').then(dataV => {
                      Vue.use(dataV.default || dataV)

                      import('echarts').then(echarts => {
                        // ✅ 全局变量注册
                        Vue.prototype.$http = httpRequest.default || httpRequest
                        Vue.prototype.$echarts = echarts
                        Vue.prototype.isAuth = require('@/utils').isAuth
                        Vue.prototype.$message = ElementUI.Message

                        // ✅ 注册 Snap.svg
                        const Snap = require('imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js')
                        Vue.prototype.$Snap = Snap

                        // ✅ 全局调试
                        Vue.config.productionTip = false
                        Vue.config.devtools = process.env.NODE_ENV === 'development'

                        // ✅ 加载 App.vue 并挂载
                        import('./App.vue').then(App => {
                          new Vue({
                            el: '#app',
                            router: router.default,
                            store: store.default,
                            render: h => h(App.default)
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  })
}